const registerAnimations = () => {
  const $ = window.$;
  
  var windowHeight = window.innerHeight;
  var prepare = windowHeight/3;

  // Section 2
  $(document).ready(function(){
    var windowScroll = $(window).scrollTop();
    if($('.sec2 h2').length){
      var sec2 = $('.sec2 h2').offset().top;
      
      if((windowScroll + windowHeight -  prepare*0) > sec2){
        $('.sec2 h').addClass('animate');
      }

      $(window).on('scroll', function(){
        windowScroll = $(window).scrollTop();
        sec2 = $('.sec2 h2').offset().top;	
        if((windowScroll + windowHeight -  prepare*0) > sec2){
          $('.sec2 h2').addClass('animate');
        }
      });
    }
  });

  // Section 5
  $(document).ready(function(){
    var windowScroll = $(window).scrollTop();

    if($('.sec5 ').length){
      var sec5 = $('.sec5').offset().top;
      
      if((windowScroll + windowHeight -  prepare*0) > sec5){
        $('.sec5 .glow-effect-3').addClass('animate fadeInDown');
        $('.sec5 .glow-effect-4').addClass('animate fadeInUp');
      }
      $(window).on('scroll', function(){
        windowScroll = $(window).scrollTop();
        sec5 = $('.sec5').offset().top;	
        if((windowScroll + windowHeight -  prepare*0) > sec5){
          $('.sec5 .glow-effect-3').addClass('animate fadeInDown');
        }
        if((windowScroll + prepare*.5) > sec5 ){
          $('.sec5 .glow-effect-4').addClass('animate fadeInUp');
        }
      });
    }
  });


  // section 6
  $(document).ready(function(){
    var windowScroll = $(window).scrollTop();

    if($('.sec6').length){
      var sec6 = $('.sec6').offset().top;
      
      if((windowScroll + windowHeight -  prepare*2) > sec6){
        $('.sec6 .washable-shoe-cont .shoe-layer-1').addClass('fadeInRight');
        $('.sec6 .washable-shoe-cont .shoe-layer-2').addClass('fadeInRight');
        $('.sec6 .washable-shoe-cont .shoe-layer-effect').addClass('fadeIn');
      }

      $(window).on('scroll', function(){
        windowScroll = $(window).scrollTop();
        sec6 = $('.sec6').offset().top;	
        if((windowScroll + windowHeight -  prepare*1.25) > sec6){
          $('.sec6 .washable-shoe-cont .shoe-layer-1').addClass('fadeInRight');
          $('.sec6 .washable-shoe-cont .shoe-layer-2').addClass('fadeInRight');
          $('.sec6 .washable-shoe-cont .shoe-layer-effect').addClass('fadeIn');
        }
      });
    }
  });
};

export default registerAnimations;